import api from './api';

// 获取JD列表
export const getJdList = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/jd?page=${page}&limit=${limit}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '获取JD列表失败');
  }
};

// 获取单个JD
export const getJd = async (id) => {
  try {
    const response = await api.get(`/jd/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '获取JD详情失败');
  }
};

// 创建JD
export const createJd = async (title, content) => {
  try {
    const response = await api.post('/jd', {
      title,
      content,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '创建JD失败');
  }
};

// 更新JD
export const updateJd = async (id, title, content) => {
  try {
    const response = await api.put(`/jd/${id}`, {
      title,
      content,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '更新JD失败');
  }
};

// 删除JD
export const deleteJd = async (id) => {
  try {
    const response = await api.delete(`/jd/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.detail || '删除JD失败');
  }
};
